import React, { ReactNode } from 'react'

import Button from 'components_new/atoms/Button'

import AdvancedDialog from 'components_new/molecules/AdvancedDialog'
import { useTranslation } from 'language/translator'

interface DesktopProps {
  children: ReactNode
  onClose: () => void
  open: boolean
  title: string
}

const Desktop = (props: DesktopProps) => {
  const { children, onClose, open, title } = props
  const { t } = useTranslation()

  return (
    <>
      <AdvancedDialog
        actions={
          <Button variant="text" onClick={onClose}>
            {t('global', 'close')}
          </Button>
        }
        onClose={onClose}
        open={open}
        title={title}
      >
        {children}
      </AdvancedDialog>
    </>
  )
}

export default Desktop
